import React from 'react';
import { Text, View, StyleSheet, Image } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    footer: {
        position: 'absolute',
        bottom: 5,
        left: 3,
        right: 3,
        borderTopWidth: 1,
        borderTopColor: '#e0e0e0',
        paddingTop: 6,
    },
    footerContent: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: 7,
        color: '#666',
    },
    leftContent: {
        flexDirection: 'row',
        gap: 10,
        alignItems: 'center',
    },
    rightContent: {
        flexDirection: 'row',
        alignItems: 'center',
        textAlign: 'right',
    },
    pageNumber: {
        fontWeight: 'bold',
        marginLeft: 10,
        fontSize: 10,
    },
    dateGenerated: {
        marginRight: 10,
    },
    copyright: {
        fontStyle: 'italic',
    },
    confidentialText: {
        color: '#FF0000',
        fontSize: 8,
        fontWeight: 'bold',
        textAlign: 'center',
        marginBottom: 10,
        fontStyle: 'italic',
    },
    headerLogo: {
        width: 34,
        marginLeft: 10,
        height: 34,
    },
});

export const NewFooterSection: React.FC = () => {
    const today = new Date();
    const formattedDate = today.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });

    return (
        <View style={styles.footer} fixed>
            <View style={styles.footerContent}>
                <View style={styles.leftContent}>
                    {/* <Text style={styles.dateGenerated}>Generated on: {formattedDate}</Text> */}
                    <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
                        `Page ${pageNumber} of ${totalPages}`
                    )} />
                </View>
                <View style={styles.rightContent}>
                    <Text style={styles.confidentialText}> PRIVILEGED AND CONFIDENTIAL PROPERTY-PEPSICO</Text>
                    <Image src={'/pepsi-main.png'} style={styles.headerLogo} />
                </View>
            </View>
        </View>
    );
}; 